/// <amd-module name="Tfs/Platform/ShortcutService" />
import React = require("react");
import { Services, VssService } from "VSS/Platform/Context";
import { IVssLayoutManager, WrappedComponent } from "VSS/Platform/Layout";

/**
 * Service which defines commands used by tfs shortcuts
 */
export interface ITfsShortcutService {
    /**
     * Opens the shortcut dialog
     */
    openShortcutDialog(): void;
}

class TfsShortcutService extends VssService implements ITfsShortcutService {
    private panelOpened: boolean;

    public openShortcutDialog(): void {
        if (!this.panelOpened) {
            this.panelOpened = true;
            const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
            layoutManager.renderCallout(onDismiss => {
                return React.createElement(
                    WrappedComponent,
                    {
                        dependencies: ["ms.vss-tfs-web.keyboard-shortcuts-ui-content"],
                        wrappedType: "KeyboardShortcutsPanel",
                        onDismiss: () => {
                            this.panelOpened = false;
                            onDismiss();
                        }
                    },
                    null
                );
            });
        }
    }
}

Services.add("ITfsShortcutService", { serviceFactory: TfsShortcutService });
